// This icon file is generated automatically.
var PDeleteUserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.6 9.24c.38-.2.8-.32 1.27-.32.05 0 .07-.05.04-.09a5.8 5.8 0 00-1.62-1.02l-.02-.01a3.88 3.88 0 10-4.53 0h-.02a5.82 5.82 0 00-3.58 5.3c0 .06.06.12.13.12h.93c.07 0 .13-.06.13-.12a4.66 4.66 0 017.14-3.86c.04.02.09.02.13 0zM7 7.34a2.67 2.67 0 01-2.68-2.68 2.68 2.68 0 014.58-1.9 2.68 2.68 0 010 3.8c-.5.5-1.18.78-1.9.78zm5.75 3.72H9a.13.13 0 00-.13.13v.87c0 .07.06.13.13.13h3.75c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-delete-user", "theme": "outlined" };
export default PDeleteUserOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDeleteUserOutlined.js
// module id = 3324
// module chunks = 0